import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {SwapScheduleOccurrenceInput, ScheduleRepository} from '../ports/schedule.repository';

export class SwapScheduleOccurrence implements UseCase<[SwapScheduleOccurrenceInput], void> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(input: SwapScheduleOccurrenceInput): Promise<Result<void, ScheduleError>> {
    return this.repository.swapOccurrence(input);
  }
}
